<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-large-size-100 md-xlarge-size-33">
                <form ref="device_group_add" @submit.prevent="updateDeviceGroup">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-blue">
                            <div class="card-icon">
                                <i class="md-icon fas fa-info" />
                            </div>
                            <h4 class="title">Détail du groupement</h4>
                        </md-card-header>
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Nom</label>
                                        <md-input v-model="deviceGroup.name" name="name" type="text" required></md-input>
                                        <validation-error :errors="apiValidationErrors.name"/>
                                    </md-field>
                                </div>
                            </div>
                        </md-card-content>
                        <md-card-actions md-alignment="left">
                            <md-button type="submit" class="md-success">
                                Enregistrer
                            </md-button>
                            <md-button class="md-warning" @click="goBack">
                                Retour
                            </md-button>
                        </md-card-actions>
                    </md-card>
                </form>
            </div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-33">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>view_list</md-icon>
                        </div>
                        <h4 class="title">Gestion des quantités</h4>
                    </md-card-header>
                    <md-card-content>
                        <span class="font-bold">Gestion des quantités par défaut</span>
                        <div v-if="!deviceGroup.rule" class="mb-2">
                            Les quantités par défaut sont utilisées, pour activer les données spécifiques pour ce groupement, cliquez  <span class="cursor-pointer text-info underline" @click="addRule">ici</span>.
                        </div>
                        <div v-else id="rule" class="mb-2">
                            <form ref="add_insect_group_form" class="mb-4" @submit.prevent="updateRule">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-75 px-0">
                                        <md-field class="md-invalid">
                                            <label for="min">Min</label>
                                            <md-input
                                                type="number"
                                                v-model="deviceGroup.rule.min"
                                                name="min"
                                                id="min"
                                                min="1"
                                                required
                                            >
                                            </md-input>
                                            <validation-error :errors="apiValidationErrors.min"/>
                                        </md-field>
                                    </div>
                                </div>
                                <div class="md-layout mt-4">
                                    <div class="md-layout-item md-size-75 px-0">
                                        <md-field class="md-invalid">
                                            <label for="max">Max</label>
                                            <md-input
                                                type="number"
                                                v-model="deviceGroup.rule.max"
                                                name="max"
                                                id="max"
                                                min="2"
                                                required
                                            >
                                            </md-input>
                                            <validation-error :errors="apiValidationErrors.max"/>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-25">
                                        <md-button type="submit" class="md-success">Ajouter</md-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-33">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>bug_report</md-icon>
                        </div>
                        <h4 class="title">Gestion des insectes</h4>
                    </md-card-header>
                    <md-card-content>
                        <div id="insects-management">
                            <span class="font-bold">Ajouter un insecte</span>
                            <form ref="add_insect_group_form" class="mb-4" v-if="insects.length > 0" @submit.prevent="addInsect">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-75 px-0">
                                        <md-field>
                                            <label for="insects">Insecte *</label>
                                            <md-select
                                                v-model="insect"
                                                name="insects"
                                            >
                                                <md-option v-for="insect in insects" :key="insect.id" :value="insect.id">{{ insect.name }}</md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-25">
                                        <md-button type="submit" class="md-success">Ajouter</md-button>
                                    </div>
                                </div>
                            </form>
                            <p v-else class="mb-4">Aucun nouvel insecte à ajouter</p>
                            <span class="font-bold">Liste des insectes</span>
                            <div class="md-layout" v-if="deviceGroup.insects.length > 0">
                                <div class="md-layout-item md-size-50 px-0">
                                    <md-list class="md-dense">
                                        <md-list-item v-for="insect in deviceGroup.insects" :key="insect.id" class="mb-1">
                                            <div class="md-list-item-text flex-row items-center justify-between">
                                                <span class="w-auto">{{ insect.name }}</span>
                                                <div class="w-auto flex items-center">
                                                    <div>
                                                        <md-button class="md-icon-button md-raised md-danger"
                                                            @click="deleteInsect(insect)">
                                                            <i class="md-icon fa fa-trash" />
                                                        </md-button>
                                                        <md-tooltip md-direction="top">Supprimer</md-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </md-list-item>
                                    </md-list>
                                </div>
                            </div>
                            <p v-else>Aucun insecte lié à ce groupement</p>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-large-size-100 md-xlarge-size-50">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>add</md-icon>
                        </div>
                        <h4 class="title">Ajouter des dispositifs au groupement</h4>
                    </md-card-header>
                    <md-card-content>
                        <devices-table :devices="devices" :deviceGroup="deviceGroup"
                            @updated="getData"></devices-table>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-50">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>settings</md-icon>
                        </div>
                        <h4 class="title">Dispositifs dans le groupement</h4>
                    </md-card-header>
                    <md-card-content>
                        <devices-table :devices="deviceGroup.devices"
                            @updated="getData"></devices-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import DevicesTable from "@/pages/Sites/DeviceGroups/components/DevicesTable";
import { ValidationError } from "@/components";

// Mixins
import formMixin from "@/mixins/form-mixin";

export default {
    name: "DeviceGroupEdit",
    components: {
        ValidationError, DevicesTable
    },
    mixins: [formMixin],
    data() {
        return {
            deviceGroup: {
                devices: [],
                insects: []
            },
            devices: [],
            insects: [],
            insect: null,
        }
    },
    methods: {
        async updateDeviceGroup() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('deviceGroups/updateDeviceGroup', { deviceGroupId: this.deviceGroup.id, name: this.deviceGroup.name })
                await this.$store.dispatch('alerts/success', "Nom du groupement modifié")
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async addInsect() {
            if(this.insect) {
                try {
                    await this.$store.dispatch('deviceGroups/addDeviceGroupInsect', { deviceGroupId: this.deviceGroup.id, idInsect: this.insect })
                    await this.$store.dispatch('alerts/success', 'Insecte ajouté au groupement')
                    await this.getDeviceGroupDetails()
                    this.insect = null
                } catch (e) {
                    await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
                }
            } else {
                await this.$store.dispatch('alerts/warning', 'Veuillez sélectionner un insecte à ajouter')
            }
        },
        async deleteInsect(insect) {
            try {
                await this.$store.dispatch('deviceGroups/deleteDeviceGroupInsect', { deviceGroupId: this.deviceGroup.id, idInsect: insect.id })
                await this.$store.dispatch('alerts/success', 'Insecte supprimé du groupement')
                await this.getDeviceGroupDetails()
            } catch (e) {
                await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
            }
        },
        async getDeviceGroupDetails() {
            const { data } = await this.$store.dispatch('deviceGroups/getDeviceGroupDetails', { id: this.$route.params.deviceGroupId })
            this.deviceGroup = data
            await this.getInsects()
        },
        async getDevices() {
            const { data } = await this.$store.dispatch('devices/getDevices', { id: this.$route.params.idSite })
            this.devices = data
        },
        async getInsects() {
            const { data } = await this.$store.dispatch('insects/getInsects', { isActive: true })
            let unselected = data.map(insect => {
                if(!this.deviceGroup.insects.find(i => i.id === insect.id)) {
                    return insect
                }
            })
            this.insects = unselected.filter(insect => insect !== undefined)
        },
        async addRule() {
            const { data } = await this.$store.dispatch('deviceGroups/addRule', { deviceGroupId: this.$route.params.deviceGroupId })
            this.deviceGroup.rule = data
        },
        async updateRule() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('deviceGroups/updateRule', {
                    deviceGroupId: this.$route.params.deviceGroupId,
                    min: parseInt(this.deviceGroup.rule.min),
                    max: parseInt(this.deviceGroup.rule.max)
                })
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        getData() {
            this.getDeviceGroupDetails()
            this.getDevices()
        },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-list {
        padding: 0;
        .md-list-item {
            margin-left: 0;

            &:last-child {
                margin-bottom: 0;
            }
            .md-list-item-container {
                .md-list-item-content {
                    padding: 0;
                    min-height: 15px;
                    .md-list-item-text {
                        position: relative;
                        * {
                            font-size: .875rem !important;
                        }
                    }
                    .md-button {
                        width: auto;
                        .md-ripple {
                            padding: 0 8px;
                            svg {
                                width: 100% !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
